import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { RoutedLocaleProvider, useLocale } from "./localization";
import { FiX } from "react-icons/fi";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

import { Provider } from "react-redux";
import { createStore } from "redux";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import conversationReducer from "./redux/reducers/conversationReducer";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const store = createStore(conversationReducer);

const CloseIcon: any = FiX;
function SiteToasts() {
  const { language, t } = useLocale();
  return <ToastContainer closeButton={language === "de" ? ({ closeToast, theme }) =>
    <button type="button" className={`Toastify__close-button Toastify__close-button--${theme}`} aria-label={t("Close")} title={t("Close")} onClick={closeToast}><CloseIcon /></button>
    : undefined} />;
}

root.render(
  <BrowserRouter><RoutedLocaleProvider>
    <SiteToasts />
    <Provider store={store}>
      <App />
    </Provider>
  </RoutedLocaleProvider></BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
